import { forwardRef } from 'react'
import type { HTMLAttributes } from 'react'
import { cx } from '../../cx'
import styles from './Card.module.css'

export type CardPad = 'sm' | 'md' | 'lg' | 'flush'

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  pad?: CardPad
  /** Hover-lift + --shadow-hover (spoczynek zawsze bez cienia). */
  hover?: boolean
}

export const Card = forwardRef<HTMLDivElement, CardProps>(function Card(
  { pad = 'md', hover = false, className, ...rest },
  ref,
) {
  return (
    <div
      ref={ref}
      className={cx(styles.card, styles[pad], hover && styles.hover, className)}
      {...rest}
    />
  )
})
